import { create } from 'zustand';
import { Order } from '../types';

interface OrderStore {
  lastOrder: Order | null;
  setLastOrder: (order: Order) => void;
  clearLastOrder: () => void;
}

export const useOrderStore = create<OrderStore>((set) => ({
  lastOrder: null,
  setLastOrder: (order: Order) => set({ lastOrder: order }),
  clearLastOrder: () => set({ lastOrder: null }),
})); 